<template>
<v-col class="sortable--drop--filtered pt-1" v-if="shipmentTimeLine.length > 0" cols="4" >
  <template v-for="(timeline) in shipmentTimeLine">
    <v-timeline
      class="pa-1"
      dense
      :key="timeline.id"
    >
      <v-row v-if="timeline.distance === undefined" class="pa-0" no-gutters>
        <v-col cols="12">
          <div class="v-timeline-item">
            <span class="customTextDot distance placeholderLoader">
              <span style="color: transparent;">
                loading
              </span>
            </span>
          </div>
        </v-col>
        <v-col  cols="12">
          <div class="v-timeline-item dateTimeLoading">
            <span class="customTextDot placeholderLoader">
              <span style="color: transparent;">
                loading
              </span>
            </span>
            <span class="customTextDot date placeholderLoader">
              <span style="color: transparent;">
                loading
              </span>
            </span>
          </div>
        </v-col>
      </v-row>
      <v-row class="pa-0" no-gutters>
        <v-col cols="12" v-if="timeline.distance != null">
          <div class="v-timeline-item">
            <span class="customTextDot distance">
              {{Math.ceil( timeline.distance / 1000)}} Km
            </span>
          </div>
        </v-col>
        <DropDatetimeItem :dateTime="timeline"/>
      </v-row>
    </v-timeline>
  </template>
</v-col>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
// import moment from 'moment-timezone'
import DropDatetimeItem from '@/components/planner/DropDatetimeItem'
import { plannerHelpers } from '@/_helpers'
// import { uuid } from 'vue-uuid'
export default {
  name: 'TimeLineShipmentDrops',
  components: {
    DropDatetimeItem
  },
  props: {
    locations: { type: Array, default: () => [] },
    shipmentID: { type: String, default: null }
  },
  methods: {
    ...mapActions({
      setPlannerTimeLineLocations: 'setPlannerTimeLineLocations'
    }),
    checkIfAllLocationsIsAvailable (locationKeys, fetchedLocations) {
      if (this.locations.length > 0) {
        let availableLocations = {}
        this.locations.forEach(({ locationID }) => {
          const index = locationKeys.indexOf(locationID)
          if (index >= 0) {
            availableLocations[locationID] = fetchedLocations[locationID]
          }
        })
        return Object.values(availableLocations).length === this.locations.length ? availableLocations : false
      }
      return false
    }
  },
  computed: {
    ...mapGetters([
      'getPlannerDoc',
      'getPlannerTimelineByID',
      'getPlannerCalculateRoutes',
      'getPlannerFetchedLocations'
    ]),
    timelineArrays () {
      let timeline = []
      for (let index = 0; index < (this.locations.length - 1); index++) {
        timeline.push([this.locations[index].locationID, this.locations[index + 1].locationID])
      }
      return timeline
    },
    shipmentTimeLine () {
      let missingTimeLines = []
      this.timelineArrays.forEach((location) => {
        if (this.getPlannerTimelineByID(`${location[0]}||${location[1]}`) === null) {
          missingTimeLines.push(location)
        }
      })
      if (missingTimeLines.length > 0) {
        this.setPlannerTimeLineLocations({ timeline: this.timelineArrays })
      }
      // const start = moment.unix(this.$route.query.day).utcOffset(0).set({ hour: 8, minute: 0 }).toISOString()
      // let route = [{
      //   arrival: moment(start).unix(),
      //   serviceTime: 1800,
      //   distance: null,
      //   id: uuid.v1()
      // }]
      // this.getPlannerCalculateRoutes(this.timelineArrays).forEach((calc) => {
      //   route.push({
      //     arrival: route[route.length - 1].arrival + calc.duration,
      //     serviceTime: 1800,
      //     distance: calc.distance,
      //     id: uuid.v1()
      //   })
      // })
      // return route.length > 1 ? route : []
      return plannerHelpers.plannerCalculateRoute({ timelineArrays: this.timelineArrays, docDay: this.$route.query.day })
    }
  },
  watch: {
    getPlannerFetchedLocations: {
      deep: true,
      immediate: true,
      handler (val, oldVal) {
        if (Object.keys(val).length > 0) {
          const locations = this.checkIfAllLocationsIsAvailable(Object.keys(val), val)
          if (locations) {
            this.setPlannerTimeLineLocations({ timeline: this.timelineArrays })
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-timeline-item {
    padding: 0;
    position: relative;
    height: 22px;
    &.dateTimeLoading {
      height: 50px;
    }
    .customTextDot {
      &.placeholderLoader {
        max-height: 10px;
        min-width: 80%;
        &.distance {
          min-width: 60%;
        }
      }
      font-size: 12px;
      font-weight: bold;
      background-color: #eeeeee;
      color: #212121;
      position: absolute;
      text-align: center;
      display: inline-block;
      left: 0;
      top: 0;
      &.loading {
        left: 2px;
      }
      &.date {
        top: 20px;
        color: #777777;
      }
      .dropCardTitle {
        &.overflowEllipsis {
          max-width: 90%;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          display: inline-block;
        }
        font-size: 12px;
        font-weight: bold;
        color: #212121;
      }
      .dropCardSubTitle {
        display: inline-block;
        font-size: 10px;
        font-weight: bold;
        color: #777777;
      }
    }
  }
</style>
